'use strict';

var DeleteRuleModalDirective = function DeleteRuleModalDirective(rulesStateService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/delete-rule-modal.html'),
    controller: 'DeleteRuleModalController',
    link: function link(scope, element) {
      element.parent('.modal:first').on('show.bs.modal', function () {
        scope.selectedRulesCount = rulesStateService.getSelectedRows() ? rulesStateService.getSelectedRows().length : 0;
      });
      scope.hideDialogAndRemoveRules = function () {
        element.parent('.modal:first').one('hidden.bs.modal', function () {
          scope.removeRules();
        }).modal('hide');
      };
      scope.cancelRemoveRules = function () {
        element.parent('.modal:first').modal('hide');
      };
      element.parent('.modal:first').on('hidden.bs.modal', function () {
        scope.checkboxModal = false;
      });
    }
  };
};
DeleteRuleModalDirective.$inject = ['RulesStateService'];
module.exports = DeleteRuleModalDirective;